var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.6,
    height: 74.7,
    viewBox: "0 0 235.6 74.7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003869;}.cls-2{fill:#007bc3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,31.7l4.3-.2c.2,1.4.5,3.1,2.1,3.1,1.3,0,1.7-1.1,1.7-2.2,0-1.3-.8-2.3-2.2-3.5l-2.3-2.2C1.5,24.7.2,22.8.2,20.2c0-3.3,2-6,6.2-6,2.9,0,5.7,1.5,5.9,6.7l-4.1.2c-.2-1.7-.5-3.1-2-3.1-1.2,0-1.6.9-1.6,2,0,1.3,1.3,2.4,2.4,3.5l2,2c2.3,2.2,3.5,4.2,3.5,6.8.2,3.3-2.4,6-5.7,6.2h-.6c-3.7,0-6-2.7-6.2-6.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.4,18.5h-4.5v-3.9h13.6v3.9h-4.4v19.6h-4.7v-19.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.3,14.6h6.4l4.6,23.6h-4.7l-1-5.3h-4.8l-.9,5.3h-4.3l4.7-23.6ZM35.8,29.1l-1.6-9.3h-.1l-1.6,9.3h3.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.3,14.6h6.8c3.6,0,6.4,1.8,6.4,5.7v11.9c0,4.1-2.8,6-6.4,6h-6.8V14.6ZM49.7,34.1c1.1.1,2-.8,2.1-1.9v-11.5c.1-1.1-.7-2-1.8-2.1h-2v15.5s1.7,0,1.7,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.3,18.5h-4.5v-3.9h13.6v3.9h-4.4v19.6h-4.7v-19.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.1,14.6h4.6l1.9,14h.1l2-14.1h4.5l2,14h.1l1.9-14h4.1l-3.8,23.6h-4.3l-2.3-15h-.2l-2.4,15h-4.4l-3.8-23.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.5,14.6h11.3v3.9h-6.7v5.6h5.3v3.9h-5.3v6.1h6.8v4h-11.4V14.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.8,14.6h6.8c3.9,0,6.4,2.2,6.4,7,0,3.4-1.1,5.3-2.7,6.2l3.1,10.4h-4.8l-2.4-9.3h-1.6v9.3h-4.6V14.6h-.2ZM116.2,25.3c1.3,0,2.1-.9,2.1-3.5,0-2.2-.7-3.4-2.1-3.4h-1.6v6.8l1.6.1h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126,14.6h4.6v10.4l4.6-10.4h4.6l-4.2,9.2,4.2,14.3h-4.9l-2.7-10.4-1.6,2.7v7.7h-4.6V14.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.4,14.6h11.3v3.9h-6.7v5.6h5.3v3.9h-5.3v6.1h6.8v4h-11.4V14.6h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.1,14.6h2.3v11.8l6.2-11.9h2.3l-4.6,9,4.7,14.6h-2.4l-4-12.4-2.2,4v8.4h-2.3V14.6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.3,14.6h2.3v23.6h-2.3V14.6Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.9,14.6h8.8v1.8h-6.6v8.3h5.3v2h-5.3v9.4h6.6v2h-8.8V14.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.6,14.6h2.2v21.6h6.6v2h-8.9l.1-23.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.1,4.4l-.6,2.5h3.6l-4.2,16.5h2.8l4.9-19h-6.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228,0l-4.7,18.8v-5h-2.4v1.8h-1.4l2.8-11.2h-1.8l1.1-4.4h-.7l-5.3,20.8h-3.6l2.2-8.6c.5-2.1.6-2.5.9-4.1.5-1.6-.5-3.3-2.2-3.8-.3-.1-.6-.2-1-.1-2,0-3.6,1.2-3.6,3.2v1.5h2.7v-1.4c0-.4.3-.8.7-.8s.6.3.6.9c-.1.9-.3,1.9-.5,2.8l-3.3,12.8h6.4l-1.1,4.4h.7l2.4-9.7h3.8v5.3h1.3l-1.1,4.4h2.2L230,0h-2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.9,62.9h6.5v1.7H2.9v2.1h3.7v1.7h-3.7v3.8H.9v-9.3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.2,65.4h1.8v1.1h0c.4-.7,1.3-1.2,2.1-1.2h.6v1.7c-.3,0-.5-.1-.8-.1-1,0-2,.5-2,1.7v3.5h-1.7v-6.7Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.7,62.7h1.9v1.8h-1.9v-1.8ZM13.7,65.4h1.9v6.7h-1.9v-6.7Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.8,71.1l1.1-1.1c.4.5,1.1.8,1.9.8.6,0,1.2-.2,1.2-.7s-.3-.6-1.1-.7c0,0-.7-.1-1-.2-1.1-.2-1.8-.8-1.8-1.8,0-1.4,1.2-2.3,2.8-2.3,1.2,0,2.1.3,2.7,1l-1.2,1c-.4-.4-.9-.6-1.5-.6s-1,.2-1,.6.5.5,1.1.6l1.1.2c1.2.2,1.8.9,1.8,1.9,0,1.6-1.7,2.3-3,2.3-1.3.2-2.4-.1-3.1-1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.8,69.6v-1.3c0-2,1.5-3,3.2-3,1.5,0,3,.9,3,2.6v.2h-1.8v-.2c0-.8-.6-1.1-1.2-1.1-.7,0-1.3.4-1.3,1.2v1.6c0,.8.5,1.2,1.3,1.2.6,0,1.2-.3,1.2-1.1v-.1h1.8v.2c0,1.7-1.5,2.5-3,2.5-1.6,0-3.2-.9-3.2-2.7Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.1,62.9h1.9v3.4h0c.5-.7,1.2-1,1.9-1,1.4,0,2.3.8,2.3,2.4v4.5h-1.9v-3.9c0-.8-.4-1.4-1.1-1.4-.8,0-1.2.5-1.2,1.5v3.8h-1.9s0-9.3,0-9.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.5,69.6v-1.3c0-2,1.5-3,3.2-3,1.5,0,3,.9,3,2.7v1.3h-4.2v.3c0,.8.7,1.2,1.5,1.2.6,0,1.3-.3,1.6-.7l1,1c-.6.9-1.7,1.3-2.8,1.3-1.8-.1-3.3-.9-3.3-2.8ZM42.8,68.1v-.2c0-.8-.6-1.2-1.2-1.2s-1.2.4-1.2,1.2v.1l2.4.1h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.1,62.9h6.6v1.7h-4.6v2h4v1.7h-4v2.1h4.7v1.7h-6.7v-9.2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.2,65.4h1.8v.8h0c.5-.7,1.2-1,2-1,1.4,0,2.3.8,2.3,2.4v4.5h-1.9v-3.9c0-.8-.4-1.4-1.1-1.4-.8,0-1.2.5-1.2,1.5v3.8h-1.9s0-6.7,0-6.7Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.6,69.6v-1.3c0-2,1.5-3,3.2-3,1.5,0,3,.9,3,2.7v1.3h-4.2v.3c0,.8.7,1.2,1.5,1.2.6,0,1.3-.3,1.6-.7l1,1c-.6.9-1.7,1.3-2.8,1.3-1.8-.1-3.3-.9-3.3-2.8ZM68.9,68.1v-.2c0-.8-.6-1.2-1.2-1.2s-1.2.4-1.2,1.2v.1l2.4.1h0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72,65.4h1.8v1.1h0c.4-.7,1.3-1.2,2.1-1.2h.6v1.7c-.3,0-.5-.1-.8-.1-1,0-2,.5-2,1.7v3.5h-1.9v-6.7h.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.4,73.4l1.3-.9c.4.5,1,.8,1.6.8.9,0,1.4-.6,1.4-1.5v-.7h0c-.5.6-1.1.9-1.8.9-1.6,0-2.6-.9-2.6-2.6v-1.4c0-1.7,1.2-2.7,2.6-2.7.7,0,1.4.4,1.8.9h0v-.8h1.8v6.1c0,1.8-1.1,3.2-3.3,3.2-1.1,0-2.3-.4-2.8-1.3ZM81.7,69.3v-1.4c0-.8-.6-1.2-1.3-1.2-.6,0-1.2.3-1.2,1.2v1.5c0,.8.6,1.2,1.3,1.2.5-.1,1.2-.4,1.2-1.3Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.1,62.7h1.9v1.8h-1.9v-1.8ZM85.1,65.4h1.9v6.7h-1.9v-6.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.3,69.6v-1.3c0-2,1.5-3,3.2-3,1.5,0,3,.9,3,2.7v1.3h-4.2v.3c0,.8.7,1.2,1.5,1.2.6,0,1.3-.3,1.6-.7l1,1c-.6.9-1.7,1.3-2.8,1.3-1.8-.1-3.3-.9-3.3-2.8ZM92.6,68.1v-.2c0-.8-.6-1.2-1.2-1.2s-1.2.4-1.2,1.2v.1l2.4.1h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.2,66.8h-.9v-1.4h.9v-.8c0-1.3.8-2,2-2,.3,0,.7,0,1,.1v1.4c-.2,0-.4-.1-.6-.1-.3,0-.5.1-.5.5v.8h1.2v1.4h-1.2v5.3h-1.8l-.1-5.2h0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.2,69.9v-4.5h1.9v3.9c0,.8.4,1.4,1.2,1.4s1.2-.5,1.2-1.5v-3.8h1.9v6.7h-1.8v-.9h0c-.5.7-1.2,1-2,1-1.5.1-2.4-.8-2.4-2.3ZM104,62.7h1.7v1.8h-1.7v-1.8ZM106.8,62.7h1.7v1.8h-1.7v-1.8Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.8,65.4h1.8v1.1h0c.4-.7,1.3-1.2,2.1-1.2h.6v1.7c-.3,0-.5-.1-.8-.1-1,0-2,.5-2,1.7v3.5h-1.9v-6.7h.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.1,69.7v-1.8c0-1.7,1.2-2.6,2.7-2.6.7,0,1.3.3,1.7.8h0v-3.2h1.9v9.3h-1.8v-.8h0c-.4.5-1.3.9-1.9.9-1.5,0-2.6-.9-2.6-2.6ZM123.6,69.6v-1.6c0-.8-.6-1.2-1.3-1.2-.6,0-1.2.3-1.2,1.2v1.6c0,.8.6,1.2,1.3,1.2.5,0,1.2-.3,1.2-1.2Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,62.7h1.9v1.8h-1.9v-1.8ZM127,65.4h1.9v6.7h-1.9v-6.7Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.2,69.6v-1.3c0-2,1.5-3,3.2-3,1.5,0,3,.9,3,2.7v1.3h-4.2v.3c0,.8.7,1.2,1.5,1.2.6,0,1.3-.3,1.6-.7l1,1c-.6.9-1.7,1.3-2.8,1.3-1.7-.1-3.3-.9-3.3-2.8ZM134.5,68.1v-.2c0-.8-.6-1.2-1.2-1.2s-1.2.4-1.2,1.2v.1l2.4.1h0Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.4,70.7l4.4-6.1h-4.2v-1.7h6.7v1.5l-4.4,6.1h4.4v1.7h-7v-1.5s.1,0,.1,0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.7,69.9v-4.5h1.9v3.9c0,.8.4,1.4,1.2,1.4s1.2-.5,1.2-1.5v-3.8h1.9v6.7h-1.8v-.9h0c-.5.7-1.2,1-2,1-1.5.1-2.4-.8-2.4-2.3Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.3,62.9h1.9v5.2l2.3-2.7h2.1l-2.2,2.5,2.3,4.3h-2.1l-1.6-3-.8.9v2.1h-1.9v-9.3Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.6,69.9v-4.5h1.9v3.9c0,.8.4,1.4,1.2,1.4s1.2-.5,1.2-1.5v-3.8h1.9v6.7h-1.8v-.9h0c-.5.7-1.2,1-2,1-1.5.1-2.4-.8-2.4-2.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.2,65.4h1.8v.8h0c.5-.7,1.2-1,2-1,1.4,0,2.3.8,2.3,2.4v4.5h-1.9v-3.9c0-.8-.4-1.4-1.1-1.4-.8,0-1.2.5-1.2,1.5v3.8h-1.9v-6.7h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.2,66.8h-.9v-1.4h.9v-.8c0-1.3.8-2,2-2,.3,0,.7,0,1,.1v1.4c-.2,0-.4-.1-.6-.1-.3,0-.5.1-.5.5v.8h1.2v1.4h-1.2v5.3h-1.8l-.1-5.2h0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.6,70.5v-3.6h-.9v-1.4h.9v-2h1.9v2h1.4v1.4h-1.4v3.2c0,.4.2.6.6.6.3,0,.5,0,.8-.1v1.5c-.4.1-1,.2-1.3.2-1.1,0-2-.5-2-1.8Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.9,70.1h2v2.1h-2v-2.1Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.59aa2b7552a06c463f0911e7c5df44a8.svg";